// ui
import { Icon, IconProps } from "@chakra-ui/react";

export const ChevronRightIcon = (props: IconProps) => (
  <Icon viewBox="0 0 16 32" fill="none" {...props}>
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M1.3375 1.17994C1.86883 0.656882 2.72357 0.66359 3.24663 1.19492L15.6602 13.8049C16.9594 15.1246 16.9594 17.1594 15.6602 18.4791L3.24663 31.0891C2.72357 31.6204 1.86883 31.6271 1.3375 31.104C0.806169 30.581 0.79946 29.7262 1.32251 29.1949L13.736 16.585C14.0007 16.3161 14.0007 15.9679 13.736 15.699L1.32251 3.08907C0.79946 2.55774 0.806169 1.70299 1.3375 1.17994Z"
      fill="currentColor"
    />
  </Icon>
);
